export class User {
    id: number;
    loginname: string;
}
